(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.headerSpacer = this.findHeaderSpacer();

      this.updateHeaderMetrics();
      this.setHeaderHeightLive();
      this.observeHeaderSize();

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.updateHeaderMetrics();
          this.setHeaderHeightLive();
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    findHeaderSpacer() {
      const next = this.header?.nextElementSibling;
      if (
        next?.classList.contains('section-spacer') &&
        next.classList.contains('shopify-section-group-header-group')
      ) {
        return next;
      }
      return null;
    }

    observeHeaderSize() {
      if (!this.header || typeof ResizeObserver === 'undefined') return;

      this.headerResizeObserver = new ResizeObserver(() => {
        if (this.header.classList.contains('shopify-section-header-hidden')) return;
        this.scheduleHeaderHeightSync();
      });

      this.headerResizeObserver.observe(this.header);
    }

    scheduleHeaderHeightSync() {
      if (this.headerHeightSyncFrame) return;

      this.headerHeightSyncFrame = requestAnimationFrame(() => {
        this.headerHeightSyncFrame = null;
        this.syncHeaderHeightLive();
      });
    }

    syncHeaderHeightLive(zero = false) {
      const isVisible = !zero && !this.header.classList.contains('shopify-section-header-hidden');
      const headerBarHeight = isVisible ? this.header.offsetHeight : 0;
      const spacerHeight = isVisible && this.headerSpacer ? this.headerSpacer.offsetHeight : 0;
      const totalHeight = headerBarHeight + spacerHeight;

      this.headerHeight = totalHeight;
      document.documentElement.style.setProperty('--header-bar-height', `${headerBarHeight}px`);
      document.documentElement.style.setProperty('--header-spacer-height', `${spacerHeight}px`);
      document.documentElement.style.setProperty('--header-height', `${totalHeight}px`);
      document.documentElement.style.setProperty('--header-bar-height-live', `${headerBarHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${totalHeight}px`);
    }

    updateHeaderMetrics() {
      this.syncHeaderHeightLive();
    }

    setHeaderHeightLive(event, zero) {
      if (this.headerHeightSyncFrame) {
        cancelAnimationFrame(this.headerHeightSyncFrame);
      }

      this.headerHeightSyncFrame = requestAnimationFrame(() => {
        this.headerHeightSyncFrame = null;
        this.syncHeaderHeightLive(!!zero);
      });
    }

    setScrolledPastHeader(scrolledPast) {
      const wasScrolledPast = this.header.classList.contains('scrolled-past-header');
      if (scrolledPast === wasScrolledPast) return false;

      this.header.classList.toggle('scrolled-past-header', scrolledPast);
      // Padding toggle causes one layout change; logo uses transform only (compositor)
      this.scheduleHeaderHeightSync();
      return true;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver?.disconnect();
      if (this.headerHeightSyncFrame) {
        cancelAnimationFrame(this.headerHeightSyncFrame);
        this.headerHeightSyncFrame = null;
      }
      if (this.scrollRaf) {
        cancelAnimationFrame(this.scrollRaf);
        this.scrollRaf = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.scrollRaf) return;

      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        const headerTop = this.headerBounds?.top || 0;
        const headerBottom = this.headerBounds?.bottom || 0;
        // Hysteresis: different enter/exit points prevent expand/collapse flicker
        // when the bar height change shifts scroll around the threshold.
        const compactEnterAt = headerBottom + 16;
        const compactExitAt = Math.max(0, headerTop + 8);

        if (scrollTop >= compactEnterAt) {
          this.setScrolledPastHeader(true);
        } else if (scrollTop <= compactExitAt) {
          if (this.setScrolledPastHeader(false)) {
            this.header.classList.remove('scrolling-down', 'scrolling-up');
            requestAnimationFrame(this.reset.bind(this));
          }
        }

        // Direction / hide-reveal logic keeps the scroll threshold
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) {
          this.currentScrollTop = scrollTop;
          return;
        }

        const scrollDifference = scrollTop - this.currentScrollTop;
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
          if (this.preventHide) {
            this.currentScrollTop = scrollTop;
            this.lastScrollTrigger = scrollTop;
            return;
          }
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= compactExitAt) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop;
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    if (!customElements.get('metafield-html-output')) {
      class MetafieldHtmlOutput extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('script[type="application/json"]');
          if (!data) return;

          try {
            this.innerHTML = JSON.parse(data.textContent);
          } catch (error) {
            return;
          }
        }
      }

      customElements.define('metafield-html-output', MetafieldHtmlOutput);
    }
  
  } catch(e) { console.error(e); }
})();
})();
